<template>
    <Card>
        <template v-slot:title>
            <h5>Learning Outcome Details</h5>
        </template>

        <template v-slot:content>

            <div class="grid" style="width: 100%; margin: auto">
                <div class="col-12 flex justify-content-center flex-wrap" v-if="learningIdentified">
                    <Button label="Open All Tabs" class="mr-2 mb-2" @click="openAllTabs" />
                    <Button label="Collapse All Tabs" class="mr-2 mb-2" @click="closeAllTabs" />
                </div>
                <div class="col-12">
                    <Panel header="Debrief data">
                        <div class="m-0">
                            <div class="row">
                                <div class="col-left text-bold">Author:</div>
                                <div class="col-right">
                                    <span class="author">{{ props?.author }}</span>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-left text-bold">Debrief created at:</div>
                                <div class="col-right">
                                    <span class="author">{{ props?.debriefCreation }}</span>
                                </div>
                            </div>
                        </div>
                    </Panel>
                </div>
            </div>

            <div v-if="!learningIdentified">No Learning Identified</div>
            <div v-else class="container">

                <Accordion :activeIndex="0" class="incidentTab mt-3">

                    <AccordionTab v-for="(learningOutcome, index) in learningOutcomes" :key="learningOutcome.id" :header="'Learning Outcome ' + (index + 1)">
                        <div class="row">
                            <div class="col-left text-bold">Source:</div>
                            <div class="col-right">
                                <span>{{ learningOutcome.source ? learningOutcome.source.name : 'N/A' }}</span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-left text-bold">Theme:</div>
                            <div class="col-right">
                                <span>{{ learningOutcome.theme ? learningOutcome.theme.name : 'N/A' }}</span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-left text-bold">Outcome Type:</div>
                            <div class="col-right">
                                <span>{{ learningOutcome.outcome_type ? getOutcomeTypeById(learningOutcome.outcome_type) : 'N/A' }}</span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-left text-bold">Details:</div>
                            <div class="col-right">
                                <span v-html="learningOutcome.details ? learningOutcome.details : 'N/A'"></span>
                            </div>
                        </div>
                        <div class="row" v-if="learningOutcome.task && learningOutcome.task.length > 0">
                            <div class="col-left text-bold">Tasks:</div>
                            <div class="col-right">
                                <ul class="task-list">
                                    <li v-for="task in learningOutcome.task" :key="task.id">
                                        <!-- <router-link :to="{ name: 'Task', params: { id: task.id } }"> -->
                                            {{ task.title }}
                                        <!-- </router-link> -->
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="row" v-if="learningOutcome.attachments && learningOutcome.attachments.length > 0">
                            <div class="col-left text-bold">Attachments:</div>
                            <div class="col-right">
                                <div class="task-list">
                                    <ul>
                                        <li v-for="attachment in learningOutcome.attachments" :key="attachment.id">
                                            <a @click.prevent @click="downloadFile(attachment.id, attachment.caption ?? attachment.original_name)" style="cursor: pointer">
                                                {{ attachment.caption ?? attachment.original_name }}
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </AccordionTab>
                </Accordion>
            </div>
        </template>
    </Card>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import { ref, computed, onUnmounted, defineProps } from 'vue';
import { debriefStore, learningOutcomeStore } from '../../../../../store/global-stores';
import { getAllOutcomeTypes } from '../constants';
import { authApi } from '@/utilities/axios';
import { useAuthStore } from '@/modules/auth/store';
const { debrief } = storeToRefs(debriefStore);
const { learningOutcomes } = storeToRefs(learningOutcomeStore);
const props = defineProps({
    author: {
        type: String,
        default: '',
    },
    debriefCreation: {
        type: String,
        default: '',
    },
})

const learningIdentified = computed(() => {
    return debrief.value.learning;
});

const activeIndex = ref([]);
const outcome_types = getAllOutcomeTypes();

onUnmounted(() => {
    learningOutcomes.value = [];
});

const openAllTabs = () => {
    for (let i = 0; i < learningOutcomes.value.length; i++) {
        activeIndex.value.push(i);
    }
};

const closeAllTabs = () => {
    activeIndex.value = [];
};

const getOutcomeTypeById = (id) => {
    return outcome_types.find((outcome) => outcome.id == id)?.name;
};

const authStore = useAuthStore();
const company_id = computed(() => {
    return authStore.getLoggedUserCompanyId;
});

const downloadFile = async (fileId, fileName) => {

    const url = process.env.VUE_APP_API_VERSION + `/download/${fileId}?company_id=${company_id.value}`;
    authApi.get(url, { responseType: 'blob' }).then(response => {
        console.log('response', response)
        console.log('fileName', fileName)

        const blob = new Blob([response.data], { type: response.type })
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = fileName
        link.click()
        URL.revokeObjectURL(link.href)
    })

    //await fileStore.downloadFile(fileId, fileName);
};
</script>

<style lang="scss" scoped>
    .author {
        font-weight: 600;
        font-size: 1rem;
    }
</style>
